// src/auth/RoleRoute.jsx
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

export default function RoleRoute({ children, allow = [] }) {
  const { status, user } = useAuth();
  if (status !== 'authed') return <Navigate to="/login" replace />;
  const ok =
    (allow.includes('admin') && (user?.isAdmin || user?.role === "ADMIN")) ||
    (allow.includes('manager') && (user?.isManager || user?.role === "ADMIN"));
  return ok ? children : <Navigate to="/" replace />;
}
